/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiMessage } from '../../asyncapi/models/AaiMessage';
import { Aai20Message } from '../../asyncapi/v2/models/Aai20Message';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { Node } from '../../core/models/Node';

/**
 * A command used to delete a single oneOf from a message.
 * 
 * @author vvilerio
 * @extends AbstractCommand
 * @class
 */
export class DeleteOneOfMessageCommand extends AbstractCommand {
    public _oneOfIdc : number;

    public _parentPath : NodePath;

    public _oldMessage : any;

    public constructor(message? : any, oneOfIdc? : any) {
        if(((message != null && message instanceof <any>AaiMessage) || message === null) && ((typeof oneOfIdc === 'number') || oneOfIdc === null)) {
            let __args = arguments;
            super();
            if(this._oneOfIdc===undefined) this._oneOfIdc = 0;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldMessage===undefined) this._oldMessage = null;
            if(this._oneOfIdc===undefined) this._oneOfIdc = 0;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldMessage===undefined) this._oldMessage = null;
            (() => {
                this._parentPath = Library.createNodePath(message);
                this._oneOfIdc = oneOfIdc;
            })();
        } else if(message === undefined && oneOfIdc === undefined) {
            let __args = arguments;
            super();
            if(this._oneOfIdc===undefined) this._oneOfIdc = 0;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldMessage===undefined) this._oldMessage = null;
            if(this._oneOfIdc===undefined) this._oneOfIdc = 0;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldMessage===undefined) this._oldMessage = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteOneOfMessageCommand] Executing.");
        let parent : AaiMessage = <AaiMessage>this._parentPath.resolve(document);
        let res : AaiMessage = parent.deleteOneOfMessage(this._oneOfIdc);
        let isOneOfMessage : boolean = res._isOneOfMessage;
        if(!isOneOfMessage) {
            return;
        }
        if(!this.isNullOrUndefined(res)) {
            this._oldMessage = Library.writeNode(res);
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteOneOfMessageCommand] Reverting.");
        if(this.isNullOrUndefined(this._oldMessage)) {
            return;
        }
        let parent : AaiMessage = <AaiMessage>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let message : AaiMessage = new Aai20Message(parent);
        Library.readNode(this._oldMessage, message);
        message.setIsOneOfMessage(true);
        parent.addOneOfMessage(message, this._oneOfIdc);
    }
}
DeleteOneOfMessageCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteOneOfMessageCommand";
DeleteOneOfMessageCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




